
let apiUrl = `${window.location.protocol}//${window.location.host}/api/`;

if (process.env.NODE_ENV === 'development') {
  apiUrl = 'https://localhost:44320/api/';
}

export default apiUrl



// WEBPACK FOOTER //
// ./src/config/api.js